var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"text-center",attrs:{"show":"","variant":_vm.variant}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Real Biological Age")]),_c('h6',[_vm._v(_vm._s(_vm.coeff)+" лет")]),_c('h6',{staticClass:"alert-heading"},[_vm._v(" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }